import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Grid, Stack, useTheme } from "@mui/material";
import { IconType } from "../../icons/IconType";
import { Icon } from "../../icons/Icon";

export const ShortcutItem: FunctionComponent<IShortcutItemProps> = ({
  className,
  iconType,
  title,
  onClick
}) => {
  const theme = useTheme();
  return (
    <Grid item xs className={className}>
      <Card
        className={styles.card}
        elevation={5}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.background.default,
          borderRadius: "20px"
        }}
      >
        <CardActionArea sx={{ padding: 3, height: "100%" }} onClick={onClick}>
          <Stack spacing={2} className={styles.stack}>
            <Icon type={iconType} />
            <p className={styles.title}>{title}</p>
          </Stack>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export interface IShortcutItemProps {
  className?: string;
  iconType: IconType;
  title: string;
  onClick?: () => void;
}
